import { SimpleMarkdown } from '@/frontend/components/SimpleMarkdown'

interface Props {
  content: string
  imageSources?: Record<string, string>
  allowVideos?: boolean
  className?: string
}

export default function AcademyMarkdown({ content, imageSources = {}, allowVideos = false, className }: Props) {
  const safeContent = content.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, (_match, alt: string, source: string) => {
    const key = source.startsWith('academy-image:') ? source.slice('academy-image:'.length) : ''
    return key && imageSources[key] ? `![${alt}](${imageSources[key]})` : `[${alt || 'Imagem'}](${source})`
  })

  return <SimpleMarkdown content={safeContent} allowImages allowVideoEmbeds={allowVideos} className={className} />
}
